import { MillisecondObj } from './millisecond-model'

/**
 * Model object to store information related to a Segment of a Slice
 */
class SegmentInfoObj {
  constructor() {
    this.indexID = ''
    this.duration = ''
    this.originAirportCode = ''
    this.destinationAirportCode = ''
    this.marketingAirlineCode = ''
    this.equipmentCode = ''
    this.flightNumber = ''
    this.departureDateTime = ''
    this.arrivalDateTime = ''
    this.bookingClass = ''
    this.cabinClass = ''
    this.cabinName = ''

    this.overnightFlight = false
    this.premiumSeatingFlight = false
    this.seatMapAvailable = false
    this.seatSelectionAllowed = false
    this.genericSeatAssigned = true
    this.genericSeatAssignmentCost = 0.0
  }

  getIndexID() {
    return this.indexID
  }

  setIndexID(indexID) {
    this.indexID = indexID
  }

  getDuration() {
    return this.duration
  }

  setDuration(duration) {
    this.duration = new MillisecondObj(duration)
  }

  getOriginAirport() {
    return this.originAirportCode
  }

  setOriginAirport(originAirportCode) {
    this.originAirportCode = originAirportCode
  }

  getDestinationAirport() {
    return this.destinationAirportCode
  }

  setDestinationAirport(destinationAirportCode) {
    this.destinationAirportCode = destinationAirportCode
  }

  getAirline() {
    return this.marketingAirlineCode
  }

  setAirline(marketingAirlineCodeCode) {
    this.marketingAirlineCode = marketingAirlineCodeCode
  }

  getEquipment() {
    return this.equipmentCode
  }

  setEquipment(equipmentCodeCode) {
    this.equipmentCode = equipmentCodeCode
  }

  getFlightNumber() {
    return this.flightNumber
  }

  setFlightNumber(flightNumber) {
    this.flightNumber = flightNumber
  }

  getDepartureDate() {
    return this.departureDateTime
  }

  setDepartureDate(departureDateTime) {
    this.departureDateTime = departureDateTime
  }

  getArrivalDate() {
    return this.arrivalDateTime
  }

  setArrivalDate(arrivalDateTime) {
    this.arrivalDateTime = arrivalDateTime
  }

  getBookingClass() {
    return this.bookingClass
  }

  setBookingClass(bookingClass) {
    this.bookingClass = bookingClass
  }

  getCabinClass() {
    return this.cabinClass
  }

  setCabinClass(cabinClass) {
    this.cabinClass = cabinClass
  }

  getCabinName() {
    return this.cabinName
  }

  setCabinName(cabinName) {
    this.cabinName = cabinName
  }

  isOvernightFlight() {
    return this.overnightFlight
  }

  setOvernightFlight(overnightFlight) {
    this.overnightFlight = overnightFlight
  }

  isPremiumSeatingFlight() {
    return this.premiumSeatingFlight
  }

  setPremiumSeatingFlight(premiumSeatingFlight) {
    this.premiumSeatingFlight = premiumSeatingFlight
  }

  isSeatMapAvailable() {
    return this.seatMapAvailable
  }

  setSeatMapAvailable(seatMapAvailable) {
    this.seatMapAvailable = seatMapAvailable
  }

  isSeatSelectionAllowed() {
    return this.seatSelectionAllowed
  }

  setSeatSelectionAllowed(seatSelectionAllowed) {
    this.seatSelectionAllowed = seatSelectionAllowed
  }

  isGenericSeatAssigned() {
    return this.genericSeatAssigned
  }

  setGenericSeatAssigned(genericSeatAssigned) {
    this.genericSeatAssigned = genericSeatAssigned
  }

  getGenericSeatAssignmentCost() {
    return this.genericSeatAssignmentCost
  }

  setGenericSeatAssignmentCost(genericSeatAssignmentCost) {
    this.genericSeatAssignmentCost = genericSeatAssignmentCost
  }

  update(rawSegment) {
    this.setIndexID(rawSegment.id)
    this.setDuration(rawSegment.duration)
    this.setOriginAirport(rawSegment.origAirport)
    this.setDestinationAirport(rawSegment.destAirport)
    this.setAirline(rawSegment.marketingAirline)
    this.setEquipment(rawSegment.equipmentCode)
    this.setFlightNumber(rawSegment.flightNumber)
    this.setDepartureDate(rawSegment.departDateTime)
    this.setArrivalDate(rawSegment.arrivalDateTime)
    this.setBookingClass(rawSegment.bkgClass)
    this.setCabinClass(rawSegment.cabinClass)
    this.setCabinName(rawSegment.cabinName)

    this.setOvernightFlight(rawSegment.overnightFlight)
    this.setPremiumSeatingFlight(rawSegment.premiumSeatingFlag)
    this.setSeatMapAvailable(rawSegment.seatmapAvailable)
    this.setSeatSelectionAllowed(rawSegment.seatSelectionAllowed)
    this.setGenericSeatAssigned(rawSegment.genericSeatAssgnFlag)
    if (rawSegment.genericSeatAssgnCost) {
      this.setGenericSeatAssignmentCost(rawSegment.genericSeatAssgnCost.amount)
    }
  }
}

export { SegmentInfoObj }
